/**
 * Info Enum
 */
export enum InfoStoreEnum {
  /**
   * Key
   */
  Key = 'infoStore',
  /**
   * UI Lang
   */
  UILang = 'uiLang',
  /**
   * Debug Mode
   */
  DebugMode = 'isDevMode',
}
